import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/VuyanziG";

const VuyanziGardens = () => {
  const projectId = "PRJ00061";
  const title = "VUYANZI GARDENS - KITALE";

  const mapConfig = {
    minZoom: 15,
    zoom: 16,
    bounds: [
      [40.66, -74.0],
      [40.64, -73.975],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/vuyanzi-gardens-by-optiven/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSffQ2Q8F7Hp_vJR0mqQK0cqHYhX1L43LtDhQC3HXuhuL4s5ng/viewform"
    />
  );
};

export default VuyanziGardens;
